import {Application, Screen} from '../types';

/**
 * Statistics reuse the screen page logic but live under a semantic
 * /statistics/ URL segment; regular screens keep /screen/.
 */
export const appScreenPath = (
    app: Pick<Application, 'id' | 'screens'>,
    screenId: string | number,
): string => {
    const screen = (app.screens as Screen[] | undefined)?.find(
        (s) => String(s.id) === String(screenId),
    );
    const segment = screen?.style === 'statistic' ? 'statistics' : 'screen';
    return `/app/${app.id}/${segment}/${screenId}`;
};
